export default "__VITE_ASSET__y_OSpVpW__"